<app-context-menu menuId="explorer-icons-context-menu" [actions]="fileMenuActions" #iconsMenu></app-context-menu>
<app-context-menu menuId="explorer-folder-context-menu" [actions]="currentFolderMenuActions" #folderMenu></app-context-menu>

<div class="main-div full-size bright-12 bg-{{theme.bright}} p-2" 
  (contextmenu)="showFolderContextMenu($event)"
  (click)="manageCurrentFolderClick($event)">

  <div class="internal-loader" *ngIf="isLoading"></div>

  <div *ngIf="!isMounted" class="alert non-selectable">
    <span class="text-{{theme.brightContrast}}">The current drive is not mounted.</span>
    <br>
    <br>
    <button *ngIf="canMountUnit" class="btn btn-sm btn-primary btn-outline" (click)="mountUnit()">
      Mount
    </button>
  </div>

  <ng-container *ngIf="isMounted">
    <div *ngIf="files.length===0" class="alert non-selectable text-{{theme.brightContrast}}">
      The current folder is empty.
    </div>
  
    <div *ngIf="files.length>0" class="full-size d-flex flex-row align-content-start flex-wrap">
      <app-launcher *ngFor="let file of files" #launcher 
        (contextmenu)="showFileContextMenu($event, launcher, file)"
        (click)="manageClick($event, launcher, file)" 
        [selected]="isSelected(file)" 
        [name]="file.getName() | titlecase"
        [icon]="file.icon" 
        [title]="file.path"
        [authenticationRequired]="file.security && file.security.authentication"
        class="pt-2 pl-2" 
        style="width:{{iconSize.w}}px;height:{{iconSize.h}}px;">
      </app-launcher>
    </div>
  </ng-container>
</div>